export default __webpack_public_path__ + "static/logo-17429f86653c3872217f59a7acedbab7.svg";